export function canAccessInviteWorkers(booking) {
  return booking?.requestInvoice !== true;
}

export function hasUnpaidInvoices(booking) {
  const invoices = Array.isArray(booking?.invoiceInfo) ? booking.invoiceInfo : [];
  return invoices.some(
    (inv) => Boolean(inv?.invoiceId) && inv?.isPaid !== true
  );
}

export function isUpfrontInvoicePaid(booking) {
  const invoices = Array.isArray(booking?.invoiceInfo) ? booking.invoiceInfo : [];
  const upfront = invoices.find((inv) => inv?.invoiceKind === "upfront");
  return upfront?.isPaid === true;
}

export function canAccessWorkersManagement(booking, tier) {
  if (!booking) return false;
  if (tier === "top") return booking.requestInvoice === true;
  return isUpfrontInvoicePaid(booking);
}
